export default [
  {
    name: 'goodsMange',
    path: '/workbench/goodsMange',
    meta: { title: '商品经营', topNavName: '商品经营' },
    component: () =>
      import(
        /* webpackChunkName: "goodsManage" */ '../../pages/agent/goodsManage.vue'
      ),
  },
  {
    name: 'goodsManageSku',
    path: '/workbench/goodsManageSku',
    meta: { title: '商品经营', topNavName: '商品经营' },
    component: () =>
      import(
        /* webpackChunkName: "goodsManage" */ '../../pages/agent/goodsManageSku.vue'
      ),
  },
  {
    name: 'workbench',
    path: '/workbench/index',
    meta: { title: '工作台' },
    component: () =>
      import(
        /* webpackChunkName: "agentApply" */ '../../pages/workbench/index.vue'
      ),
  },
]
